module.exports = __webpack_public_path__ + "img/member.7d0bf2fc.png";